/*eslint-disable */
let $ = window.jQuery = require('jquery');
import {
  bus
} from '../../main';
import {
  mapGetters,
  mapState
} from 'vuex';
export default {
  name: 'header-after-login',
  components: {},
  props: [],
  data() {
    return {
      firstname: '',
      lastname: '',
      email: '',
      avatar: '',
      filterinput: '',
      profileInfoData: '',
      showHomeMenu: true,
      showQuizMenu: true,
      myProfileMenu: false,
      isOpen :false,
      searchList:''
    }
  },
  computed: {
    ...mapGetters([
      'getProfileInfo'
    ]),
    ...mapState([
      'profileInfo'
    ]),
    getUserInfo() {
      if (this.$store.getters.isAuthenticated == true) {
        this.$store.dispatch('getProfile').then((res) => {
          this.firstname= this.$store.getters.getProfileInfo.first_name;
          this.lastname = this.$store.getters.getProfileInfo.last_name;
          this.email = this.$store.getters.getProfileInfo.email;
          this.avatar = this.$store.getters.getProfileInfo.profile.avatar;
          $('.app-loader').hide()
          $('.routeloader').hide()
        })
      }
    }
  },
  mounted() {
    $('.autocomplete-results').addClass("d-none")
    $('.httploader').removeClass("searchLoaderhide")
    $('.routeloader').removeClass("searchLoaderhide")
    this.isOpen = false;
    bus.$on('showHomeMenuBtn', (data) => {
      this.showHomeMenu = data;
    });
    bus.$on('showQuizMenubtn', (data) => {
      this.showQuizMenu = data;
    });
    bus.$on('showMyProfileMenu', (data) => {
      this.myProfileMenu = data;
    });
    bus.$on('ShowSearchKeyWord', (data) => {
      this.filterinput = data;
    });
    header: this.$store.dispatch('getAuthHeader');
    // this.$store.dispatch('inspectAccessToken');
    this.getUserInfo
    $(document).ready(function(){
      $(".autocomplete_search").click(function(){
        $('.header-search').addClass("show_search")
      })
      $(document).click(function(event) {
        if (!$(event.target).closest(".autocomplete_search, .autocomplete-results").length) {
          this.isOpen = false;
          $('.header-search').removeClass("show_search")
          $('.autocomplete-results').addClass("d-none")
          $('.httploader').removeClass("searchLoaderhide")
          $('.routeloader').removeClass("searchLoaderhide")
        }
      });
      $(".headeruserimg .dropdown").click(function(){
        $(".headeruserimg .dropdown").addClass('show')
        $('.headeruserimg .dropdown-menu').addClass('show')
      })
      $(document).click(function(event) {
        if (!$(event.target).closest(".headeruserimg, .dropdown-menu").length) {
          $(".headeruserimg .dropdown").removeClass('show')
          $('.headeruserimg .dropdown-menu').removeClass('show')
        }
      });
    })
  },
  methods: {
    handleScroll() {
      let header = document.querySelector(".header_fix");
      if (window.scrollY > 30 && !header.className.includes('darkBg')) {
        header.classList.add('darkBg');
      } else if (window.scrollY < 30) {
        header.classList.remove('darkBg');
      }
    },
    getImgUrl(pic) {
      if (pic == '' || !pic || pic == 'undefined') {
        return require('./../../assets/images/user_default.png')
      } else {
        return pic
      }
    },
    logOutUser() {
      if ('BroadcastChannel' in self) {
        authChannel.postMessage({
          cmd: 'logout'
        })
      }
    },
    logout: function() {
      this.$store.dispatch('logout')
        .then(() => {
          this.logOutUser()
          this.$router.push('/login')
        })
    },
    toggleSearch: function() {
      let windowWidth = $(window).width();
      if ((windowWidth < 801) && (windowWidth > 581)) {
        $('.header-search').toggleClass('showSearch', 7000);
        $(this).closest('div').find('.form-control').focus();
      }
    },
    onChange(){
      $('.header-search').addClass("show_search")
      if(this.filterinput.length >= 3){
        $('.httploader').addClass("searchLoaderhide")
        $('.routeloader').addClass("searchLoaderhide")
        this.isOpen = true;
        $('.autocomplete-results').removeClass("d-none")
        this.$store.dispatch('filterField', { name: this.filterinput }).then((response) => {
          if (response.data.code == '2000') {
            this.searchList = response.data.data.results
          }
        })
      }else{
        this.isOpen = false;
      }
    },
    searchListFind(SearchKeyName){
      if(SearchKeyName){
        $('.httploader').removeClass("searchLoaderhide")
        $('.routeloader').removeClass("searchLoaderhide")
        this.filterinput = SearchKeyName
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$router.push('/courses/search/result/' + SearchKeyName + '/')
            this.isOpen = false;
            this.$validator.reset()
          }
        })
      }
    },
    filtercourse() {
      if (this.filterinput) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$router.push('/courses/search/result/' + this.filterinput + '/')
            this.$validator.reset()
          }
        })
      }
    },
    logoClick: function() {
      $('body').removeClass('show');
      $('.mobilemenu-icon').removeClass('open');
      this.$router.push('/');
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  beforeMount() {
    this.getUserInfo;
  },
  watch: {
    getUserInfo(){
      this.firstname= this.$store.getters.getProfileInfo.first_name;
      this.lastname = this.$store.getters.getProfileInfo.last_name;
      this.email = this.$store.getters.getProfileInfo.email;
      this.avatar = this.$store.getters.getProfileInfo.profile.avatar;
      return;
    },
  }
}